import React from 'react'
import { Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export const GetTouch = () => {
  return (
    <section className='digital-section'>
      <Row className='align-items-center'>
        <div className='col-lg-4' data-aos="fade-right" data-aos-duration="2000">
          <div className='digital-flex'>
            <div className='digital-content'>
              <h3>Are you ready to start</h3>
              <h5>your digital transformation?</h5>
              <Link to='/contact'>
                <button className='touch-btn'>Get In Touch</button>
              </Link>
            </div>
          </div>
        </div>
        <div className="col-lg-8 d-lg-block d-none">
          <div className='digital-bg position-relative'>
            <div className='digital-img'>
              <img src="../assets/images/digital-img.png" alt="" />
            </div>

            <div className='digital-shap-11'>
              <img src="../assets/images/digital-shap-11.svg" alt="" />
            </div>
            <div className='digital-shap-1'>
              <img src="../assets/images/digital-shap-1.svg" alt="" />
            </div>
            <div className='digital-shap-2'>
              <img src="../assets/images/digital-shap-2.svg" alt="" />
            </div>
            <div className='digital-shap-3'>
              <img src="../assets/images/digital-shap-3.svg" alt="" />
            </div>
            <div className='digital-shap-4'>
              <img src="../assets/images/digital-shap-4.svg" alt="" />
            </div>
            <div className='digital-shap-5'>
              <img src="../assets/images/digital-shap-5.svg" alt="" />
            </div>
            <div className='digital-shap-6'>
              <img src="../assets/images/digital-shap-6.svg" alt="" />
            </div>
            <div className='digital-shap-7'>
              <img src="../assets/images/digital-shap-7.svg" alt="" />
            </div>
            <div className='digital-shap-8'>
              <img src="../assets/images/digital-shap-8.svg" alt="" />
            </div>
            <div className='digital-shap-9'>
              <img src="../assets/images/digital-shap-9.svg" alt="" />
            </div>
            <div className='digital-shap-10'>
              <img src="../assets/images/digital-shap-10.svg" alt="" />
            </div>
          </div>
        </div>
      </Row>
    </section>
  )
}
